module.exports = __webpack_public_path__ + "static/Lato-Italic-4eb103b4d12be57cb1d040ed5e162e9d.woff2";